module.exports = __webpack_public_path__ + "static/media/brand28.be149b22.png";